import { FormProvider } from "react-hook-form";
import { AppDialog } from "../../../../../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../../../../../common/components/button/defaultButton/DefaultButton";
import { DefaultFormSelectField } from "../../../../../../common/components/forms/inputs/dropdown/DefaultFormSelectField";
import { PriceDisplay } from "../../../../../../common/components/PriceDisplay/PriceDisplay";
import { useRenewCardDialog } from "./hooks/useRenewCardDialog";
import styles from "./RenewCardDialog.module.scss";

interface IRenewCardDialogProps {
  userId?: number;
  visible: boolean;
  onHide: () => void;
}

export const RenewCardDialog = ({
  userId,
  visible,
  onHide,
}: IRenewCardDialogProps) => {
  const {
    form,
    selectOptions,
    hasSeveralOptions,
    summary,
    isOptionsLoading,
    loadErrorMessage,
    isEmpty,
    canRenew,
    isRenewing,
    handleRenew,
  } = useRenewCardDialog({ userId, visible, onHide });

  return (
    <AppDialog
      header="Подновяване на карта"
      visible={visible}
      onHide={onHide}
      className={styles.dialog}
    >
      <FormProvider {...form}>
        <form className={styles.form} onSubmit={handleRenew}>
          <p className={styles.explanation}>
            Нова карта със същия план, цена, брой посещения и начин на плащане
            като последната.
          </p>

          {isOptionsLoading && <p className={styles.hint}>Зареждане...</p>}

          {loadErrorMessage && (
            <p className={styles.error} role="alert">
              {loadErrorMessage}
            </p>
          )}

          {isEmpty && (
            <p className={styles.hint}>
              Клиентът няма карта, която може да бъде подновена.
            </p>
          )}

          {hasSeveralOptions && (
            <DefaultFormSelectField
              name="subscriptionId"
              label="Карта"
              options={selectOptions}
              filter={false}
              required
              width="100%"
            />
          )}

          {summary && (
            <div className={styles.summary} data-testid="renew-card-summary">
              <p className={styles.summary_title}>
                {summary.planName}
                {summary.planTypeName && (
                  <span className={styles.summary_type}>
                    {" "}
                    · {summary.planTypeName}
                  </span>
                )}
              </p>
              <ul className={styles.summary_rows}>
                <li>{summary.visitsLabel}</li>
                <li>
                  Цена:{" "}
                  <PriceDisplay
                    minPrice={summary.pricePaid}
                    currencyId={summary.currencyId}
                    className={styles.summary_value}
                  />
                </li>
                <li>
                  Начин на плащане:{" "}
                  <span className={styles.summary_value}>
                    {summary.paymentTypeLabel}
                  </span>
                </li>
                <li className={styles.summary_value}>{summary.validityLabel}</li>
              </ul>
              {summary.startNote && (
                <p className={styles.summary_note}>{summary.startNote}</p>
              )}
            </div>
          )}

          <div className={styles.footer}>
            <DefaultButton
              label="Поднови"
              type="submit"
              disabled={!canRenew}
              loading={isRenewing}
            />
          </div>
        </form>
      </FormProvider>
    </AppDialog>
  );
};
